import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { environment } from "@environments/environment";
import { CloudimageCropPipe } from "../pipe/cloudimage.pipe";

@Component({
    selector: 'app-round-image',
    standalone: true,
    imports: [CommonModule, CloudimageCropPipe],
    templateUrl: './round-image-display.component.html',
    styleUrls: [`./style/round-image-display.component.scss`],
})
export class RoundImageDisplayComponent implements OnInit {
    @Input() url!: string;
    @Input() useDefaultMissingImage: boolean = true;
    @Input() width = 60;
    @Input() height = 60;

    constructor() {
        // console.log(`UploadComponent ctor`);
    }

    ngOnInit(): void {

    }

    noProfileImage = environment.resources.imageNoProfileUrl;
}
